/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data as useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation,
	useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$variables as useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutationVariables,
} from '../__generated__/useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data } from '../__generated__/useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation.graphql.ts';
export type useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation_createPersonalSpace_Space_icon_Icon = NonNullable<NonNullable<useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data['createPersonalSpace']>['icon']>;
export type useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation_createPersonalSpace_Space = NonNullable<useCreatePersonalSpaceOnboardingCreatePersonalSpaceMutation$data['createPersonalSpace']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum InitialPermissionOptions {
  COPY_FROM_SPACE = "COPY_FROM_SPACE",
  DEFAULT = "DEFAULT",
  PRIVATE = "PRIVATE",
}

